/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { addTabRedirect } from 'DesignData/actions/Tabs';
import { fetchContents } from 'DesignData/actions/finder/Folders';
import { selectFile, deselectAsset } from 'DesignData/actions/finder/Selections';
export function addStagedFile(liveFile, stagedFile) {
  return dispatch => {
    const liveFileId = liveFile.id;
    const stagedFileId = stagedFile.id; // If live file ID is a path, don't set new ID

    if (typeof liveFileId === 'string' || liveFileId === stagedFileId) return; // Reload the asset's parent folder in finder to display the correct
    // file ids, as there will be a new id for the staged file

    dispatch(fetchContents(liveFile.folderId)).then(() => {
      dispatch(addTabRedirect(liveFileId, stagedFileId)); // Changes URL to the staged file id so refreshing loads the correct file

      window.history.pushState({}, '', stagedFileId); // Replace selected finder file with staged file

      dispatch(deselectAsset(liveFileId));
      dispatch(selectFile(stagedFileId, stagedFile.fileType, stagedFile.folderId));
    });
  };
}